/* eslint-disable camelcase */
import * as z from 'zod'

export const schema = z.object({
  fbtReason: z
    .string({ required_error: 'Please select a reason' })
})
